import { render, staticRenderFns } from "./FlaggedMes.vue?vue&type=template&id=7057be98&scoped=true"
import script from "./FlaggedMes.vue?vue&type=script&lang=js"
export * from "./FlaggedMes.vue?vue&type=script&lang=js"
import style0 from "./FlaggedMes.vue?vue&type=style&index=0&id=7057be98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7057be98",
  null
  
)

export default component.exports